import type { notebook as EN } from '../en/notebook';

export const notebook: Record<keyof typeof EN, string> = {
  'notebook.untitled': 'Ohne Titel',
  'notebook.welcome.empty': 'Noch nichts vorhanden.',
  'notebook.welcome.body':
    'Erstelle deine erste Seite, um dein Notizbuch zu starten. Seiten, der Baum und der Editor kommen in M2.',
  'notebook.notFound.title': 'Diese Seite existiert nicht.',
  'notebook.notFound.body': 'Möglicherweise wurde sie endgültig gelöscht.',
  'notebook.notFound.back': 'Zurück zum Notizbuch',

  /* ── Tree ─────────────────────────────────────────────────────────────── */
  'notebook.pages.title': 'Seiten',
  'notebook.pages.new': 'Neue Seite',
  'notebook.pages.loading': 'Seiten werden geladen…',
  'notebook.pages.loadError': 'Der Baum konnte nicht geladen werden.',
  'notebook.pages.emptyBody': 'Erstelle deine erste Seite, um dein Notizbuch zu starten.',
  'notebook.collapse': 'Einklappen',
  'notebook.expand': 'Ausklappen',
  'notebook.pageTitleLabel': 'Seitentitel',
  'notebook.addSubpage': 'Unterseite hinzufügen',
  'notebook.notSyncedLabel': 'Noch nicht synchronisiert',
  'notebook.notSyncedTitle':
    'Auf diesem Gerät gespeichert — wird synchronisiert, sobald der Server erreichbar ist',
  'notebook.actionsFor': 'Aktionen für {title}',
  'notebook.removeFromFavorites': '{title} aus Favoriten entfernen',
  'notebook.addToFavorites': '{title} zu Favoriten hinzufügen',
  'notebook.addSubpageFor': 'Unterseite zu {title} hinzufügen',

  'notebook.archiveConfirm.title': '„{title}“ in den Papierkorb verschieben?',
  'notebook.archiveConfirm.body.one':
    'Die {count} Unterseite wird ebenfalls in den Papierkorb verschoben. Du kannst sie aus dem Papierkorb wiederherstellen.',
  'notebook.archiveConfirm.body.other':
    'Die {count} Unterseiten werden ebenfalls in den Papierkorb verschoben. Du kannst sie aus dem Papierkorb wiederherstellen.',
  'notebook.archiveConfirm.confirm': 'In den Papierkorb',
  'notebook.archivedToast': '„{title}“ in den Papierkorb verschoben.',

  'notebook.toast.createError': 'Die Seite konnte nicht erstellt werden.',

  /* ── Trash (sidebar peek + /trash room) ──────────────────────────────────── */
  'notebook.trash.title': 'Papierkorb',
  'notebook.trash.open': 'Öffnen',
  'notebook.trash.openTitle': 'Papierkorb öffnen (G dann T)',
  'notebook.trash.empty': 'Der Papierkorb ist leer.',
  'notebook.trash.restoreAriaLabel': '{title} wiederherstellen',
  'notebook.trash.restoreTitle': 'Wiederherstellen',
  'notebook.trash.deletePermanentlyAriaLabel': '{title} endgültig löschen',
  'notebook.trash.deletePermanentlyTitle': 'Endgültig löschen',
  'notebook.trash.restoringToast': '„{title}“ wird wiederhergestellt…',
  'notebook.trash.deleteConfirmTitle': '„{title}“ endgültig löschen?',
  'notebook.trash.deleteConfirmBodySimple':
    'Diese Seite und alles darunter wird endgültig gelöscht. Das kann nicht rückgängig gemacht werden.',
  'notebook.trash.deletedToast': '„{title}“ gelöscht.',
  'notebook.trash.pageCount.one': '{count} Seite',
  'notebook.trash.pageCount.other': '{count} Seiten',
  'notebook.trash.emptyTrashButton': 'Papierkorb leeren',
  'notebook.trash.loadErrorTitle': 'Der Papierkorb konnte nicht geladen werden.',
  'notebook.trash.loadErrorBody': 'Der Server hat nicht geantwortet.',
  'notebook.trash.emptyStateBody':
    'Der Papierkorb ist leer. In den Papierkorb verschobene Seiten landen hier, mit allem darunter.',
  'notebook.trash.subpageCount.one': '+{count} Unterseite',
  'notebook.trash.subpageCount.other': '+{count} Unterseiten',
  'notebook.trash.restoreButton': 'Wiederherstellen',
  'notebook.trash.deleteButton': 'Löschen',
  'notebook.trash.deleteConfirmBodyWithDescendants.one':
    'Diese Seite und ihre {count} Unterseite werden endgültig gelöscht, zusammen mit den Bildern, die nur sie verwendet haben. Das kann nicht rückgängig gemacht werden.',
  'notebook.trash.deleteConfirmBodyWithDescendants.other':
    'Diese Seite und ihre {count} Unterseiten werden endgültig gelöscht, zusammen mit den Bildern, die nur sie verwendet haben. Das kann nicht rückgängig gemacht werden.',
  'notebook.trash.deleteConfirmBodyNoDescendants':
    'Diese Seite wird endgültig gelöscht, zusammen mit den Bildern, die nur sie verwendet hat. Das kann nicht rückgängig gemacht werden.',

  /* ── Empty trash dialog ──────────────────────────────────────────────────── */
  'notebook.emptyTrash.title.one': '{count} Seite endgültig löschen?',
  'notebook.emptyTrash.title.other': '{count} Seiten endgültig löschen?',
  'notebook.emptyTrash.bodyBefore':
    'Jede Seite im Papierkorb und jedes Bild, das nur diese Seiten verwendet haben, wird vom Server gelöscht. ',
  'notebook.emptyTrash.bodyStrong': 'Das ist unwiderruflich.',
  'notebook.emptyTrash.bodyAfter': ' Es gibt kein Rückgängig und keinen Versionsverlauf.',
  'notebook.emptyTrash.confirmBefore': 'Gib ',
  'notebook.emptyTrash.confirmAfter': ' ein, um zu bestätigen.',
  'notebook.emptyTrash.deletingToast.one': '{count} Seite wird gelöscht…',
  'notebook.emptyTrash.deletingToast.other': '{count} Seiten werden gelöscht…',
  'notebook.emptyTrash.error': 'Der Papierkorb konnte nicht geleert werden.',

  /* ── PageView ─────────────────────────────────────────────────────────────── */
  'notebook.createdToast': '„{title}“ erstellt.',
  'notebook.couldntOpen': 'Diese Seite konnte nicht geöffnet werden.',
  'notebook.breadcrumbLabel': 'Breadcrumb',
  'notebook.removeFromFavoritesHeader': 'Aus Favoriten entfernen',
  'notebook.addToFavoritesHeader': 'Zu Favoriten hinzufügen',
  'notebook.archivedNotice':
    'Diese Seite befindet sich im Papierkorb. Stelle sie wieder her, um sie zu bearbeiten.',
  'notebook.offlineNotice':
    'Zeigt deine lokale Kopie — der Server ist nicht erreichbar. Schreib einfach weiter; es wird synchronisiert.',
  'notebook.switchedToServer': 'Zur Serverversion gewechselt.',
  'notebook.switchedToServerDescription': 'Deine lokale Version wurde als Sicherung behalten.',
  'notebook.undo': 'Rückgängig',

  /* ── Backlinks ────────────────────────────────────────────────────────────── */
  'notebook.backlinks.ariaLabel': 'Backlinks',
  'notebook.backlinks.title': 'Verlinkt von',
  'notebook.backlinks.none': 'Noch keine Seiten verlinken hierher.',
  'notebook.backlinks.unresolvedHeading': 'Unaufgelöste Links auf dieser Seite ({count})',
};
